export const MAX_WAIT_TIME = 7000;
